import ExcelJS from 'exceljs';
import { generateTopMatureSheet } from './generateTopMature';
import { generateStabulationVieuxSheet } from './generateStabulationVieuxSheet';
import { generatePharmaSheet } from './generatePharmaSheet';
import { generateSummarySheet } from './generateSummarySheet';
import Papa from 'papaparse';
import CDGTankMappingCsv from 'staticFiles/CDGTankMapping.csv';

export const generateXLSXCDG = async (lastOpsAndTanks, globalState, t, cellarsRef) => {
  const { lastOps, tankDataMap } = lastOpsAndTanks;
  const volumeUnit = lastOps[0]?.form.volumeUnit || 'hL';

  // Load tank mapping once
  const response = await fetch(CDGTankMappingCsv);
  const csvText = await response.text();
  const { data: tankMapping } = Papa.parse(csvText, {
    header: true,
    skipEmptyLines: true,
    delimiter: ';'
  });

  // Create workbook
  const workbook = new ExcelJS.Workbook();
  workbook.creator = 'Labox';
  workbook.lastModifiedBy = 'Labox';
  workbook.created = new Date();
  workbook.modified = new Date();

  // First worksheet (TOP Maturé)
  const ws1 = workbook.addWorksheet('TOP Maturé');
  await generateTopMatureSheet(ws1, lastOps, tankDataMap, volumeUnit, globalState.extraOperationFields, t, cellarsRef, tankMapping);

  // Set print settings for first worksheet
  ws1.pageSetup = {
    orientation: 'portrait',
    fitToPage: true,
    fitToWidth: 1,
    fitToHeight: 1,
    margins: {
      left: 0.25,
      right: 0.25,
      top: 0.75,
      bottom: 0.75,
      header: 0.3,
      footer: 0.3
    },
  };

  // Second worksheet (Stabulation vieux)
  const ws2 = workbook.addWorksheet('Stabulation vieux');
  await generateStabulationVieuxSheet(ws2, lastOps, tankDataMap, volumeUnit, cellarsRef, tankMapping);

  // Set print settings for second worksheet
  ws2.pageSetup = {
    orientation: 'portrait',
    fitToPage: true,
    fitToWidth: 1,
    fitToHeight: 1,
    margins: {
      left: 0.25,
      right: 0.25,
      top: 0.75,
      bottom: 0.75,
      header: 0.3,
      footer: 0.3
    },
  };

  // Third worksheet (TOP Pharma)
  const ws3 = workbook.addWorksheet('TOP Pharma');
  await generatePharmaSheet(ws3, lastOps, tankDataMap, volumeUnit, cellarsRef, tankMapping);

  // Set print settings for third worksheet
  ws3.pageSetup = {
    orientation: 'portrait',
    fitToPage: true,
    fitToWidth: 1,
    fitToHeight: 1,
    margins: {
      left: 0.25,
      right: 0.25,
      top: 0.75,
      bottom: 0.75,
      header: 0.3,
      footer: 0.3
    },
  };

  // Fourth worksheet (Résumé du site)
  const ws4 = workbook.addWorksheet('Résumé du site');
  generateSummarySheet(ws1, ws2, ws3, ws4);

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;

  // Write the file
  const buffer = await workbook.xlsx.writeBuffer();
  
  // Create a blob and download link
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `inventaire-${formattedDate}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
